import api from "./api";

export async function getAiProviders() {
    const res = await api.get("/dev-ai-diagnostics/providers");
    return res.data;
}

export async function testTextProvider(providerName, prompt) {
    const res = await api.post("/dev-ai-diagnostics/text/test", {
        providerName,
        prompt
    });
    return res.data;
}

export async function testImageProvider(providerName, prompt, styleHint, layoutType) {
    const res = await api.post("/dev-ai-diagnostics/image/test", {
        providerName,
        prompt,
        styleHint,
        layoutType
    });
    return res.data;
}
export async function getDbAiProviderRoutes() {
    const { data } = await api.get("/dev-ai-diagnostics/db-routes");
    return data;
}

export async function testDbAiProviderRoute(routeId, prompt, featureKey = "dev-ai-db-route-test") {
    const { data } = await api.post("/dev-ai-diagnostics/db-route/test", {
        routeId,
        featureKey,
        prompt
    });

    return data;
}

export async function testDbAiRouting(prompt, featureKey = "*", routingMode = "Balanced") {
    const { data } = await api.post("/dev-ai-diagnostics/db-routing/test", {
        featureKey,
        routingMode,
        prompt
    });

    return data;
}